import autoScroll from './auto-scroll';
import click from './click/index';
import colorOptions from './color-options';
import dateOptions from './date-options';
import datetimeOptions from './datetime-options';
import findText from './find-text';
import _global from './global';
import help from './help';
import imageOptions from './image-options';
import introduceText from './introduce-text';
import linkOptions from './link-options';
import mediaOptions from './media-options';
import monthOptions from './month-options';
import navigation from './navigation';
import open from './open';
import pickLabel from './pick-label';
import rangeOptions from './range-options';
import scroll from './scroll';
import search from './search';
import select from './select';
import selectOptions from './select-options';
import textOptions from './text-options';
import timeOptions from './time-options';
import weekOptions from './week-options';

const coreModules = [
  autoScroll,
  click,
  colorOptions,
  dateOptions,
  datetimeOptions,
  findText,
  _global,
  help,
  imageOptions,
  introduceText,
  linkOptions,
  mediaOptions,
  monthOptions,
  navigation,
  pickLabel,
  open,
  rangeOptions,
  search,
  scroll,
  select,
  selectOptions,
  textOptions,
  timeOptions,
  weekOptions,
];

export default coreModules;
